<ccl-page-header>
    <div
        class="s-page-header__left c-page-header__left editable-session-header"
    >
        <div
            class="c-title c-title--secondary text-capitalize"
            [ngStyle]="fontstyle"
        >
            {{ sessionConfig.labelConfig.label }}
        </div>
        <i class="fa fa-pencil" cclTitle="Edit Label"
            (cclClick)="openConfigDrawer('label', $event, null)">
        </i>
    </div>
    <div class="s-page-header__right"></div>
</ccl-page-header>

<ccl-page-header *ngIf="getActivatedRoute().routeConfig.path === 'general-session'">
    <div
        class="s-page-header__left c-page-header__left editable-session-header"
    >
        <div
            class="c-title c-title--secondary"
            [ngStyle]="generalfontStyle"
        >
            {{ sessionConfig.catalogConfig.searchBarText }}
        </div>
        <i class="fa fa-pencil" cclTitle="Edit Search Bar Placholder"
            (cclClick)="openConfigDrawer('searchText', $event, null)">
        </i>
    </div>
    <div class="s-page-header__right c-page-header__right">
        <ccl-toggle-button
            [title]="sessionConfig.catalogConfig.showSearchBar ? 'Enable' : 'Disable'"
            [isChecked]="sessionConfig.catalogConfig.showSearchBar"
            (isCheckedChange)="toggleHTMLEnable($event)"
            >{{ sessionConfig.catalogConfig.showSearchBar ? "Enabled" : "Disabled" }}</ccl-toggle-button
        >
    </div>
    <div class="s-page-header__right"></div>
</ccl-page-header>
<ccl-content-section>
    <div class="row row--builder">
        <div class="col col-sm-6">
            <div class="c-title--subsection">TEMPLATE USED</div>
            <span>{{ templateStyles[sessionConfig.layout] }}</span>
        </div>
        <div class="col col-sm-6">
            <ccl-basic-button
                (clickEvent)="openConfigDrawer('template', $event, null)"
                buttonStyle="c-btn--secondary pull-right"
                >Change to a Different Template
            </ccl-basic-button>
        </div>
    </div>
    <p></p>
    <div class="row row--builder align-tabs">
        <div class="col col-sm-6 tab_pad" [ngClass]="{'tab_active': selectedTab === 'public'}" (cclClick)="selectTab('public', 'selectedTab')">Public</div>
        <div class="col col-sm-6 tab_pad" [ngClass]="{'tab_active': selectedTab === 'loggedIn'}" (cclClick)="selectTab('loggedIn', 'selectedTab')">Logged In</div>
    </div>
    <p></p>
    <div class="row row--builder ">
        <div class="col col-sm-6"><div class="c-title--subsection ">COLLAPSED</div></div>
        <div class="col col-sm-6 text-right "></div>

        <div *ngIf="(((baseUrl == 'highlighted' && sessionTemplateType['highlightedStyle'] == 'list') || (baseUrl == 'promoted' && sessionTemplateType['promotedStyle'] == 'list') || (baseUrl == 'general' && sessionTemplateType['generalStyle'] == 'list')) || (!sessionTemplateType['generalStyle'] && !sessionTemplateType['promotedStyle'] && !sessionTemplateType['highlightedStyle']))" class="col col-sm-12 ">
            <div
                [class.c-box]="!hover"
                [class.c-box-nohover]="hover"
                (cclClick)="openConfigDrawer('region', $event, 'header')"
                title="Edit Region"
            >
                <div
                    *ngIf="sessionConfig.layout == 'l_circular'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.header.regionConfig.background,
                        margin: sessionConfig.catalogConfig.header.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.header.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.header.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable img"
                                [ngStyle]="{
                                    height:
                                        +sessionConfig.catalogConfig.header.imageConfig.height.slice(0, -2) +
                                        +sessionConfig.catalogConfig.header.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    width:
                                        +sessionConfig.catalogConfig.header.imageConfig.width.slice(0, -2) +
                                        +sessionConfig.catalogConfig.header.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    overflow: 'hidden'
                                }"
                                (cclClick)="openConfigDrawer('img', $event, 'header')"
                                title="Edit Session Image"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="img-info">
                                    <div
                                        class="img-content"
                                        [ngStyle]="{
                                            padding: '0px',
                                            height: sessionConfig.catalogConfig.header.imageConfig.height,
                                            width: sessionConfig.catalogConfig.header.imageConfig.width,
                                            'background-color':
                                                sessionConfig.catalogConfig.header.imageConfig.background,
                                            margin: sessionConfig.catalogConfig.header.imageConfig.margin,
                                            'border-radius':
                                                this.sessionConfig.layout == 'l_circular'
                                                    ? sessionConfig.catalogConfig.header.imageConfig.height
                                                    : '0px'
                                        }"
                                    >

                                    <div *ngIf="sessionConfig.catalogConfig['header'].imageConfig.basedOn == 'dynamic_img'" [innerHTML]="basedOnImageName['header'] | safeHtml"></div>

                                    <span *ngIf="sessionConfig.catalogConfig['header'].imageConfig.basedOn == 'speaker_img'" [ngStyle]="{
                                        display: 'inline-block',
                                        'margin-top':
                                            'calc(' +
                                            sessionConfig.catalogConfig.header.imageConfig.height +
                                            ' / 2 - 20px)'
                                    }" class="fs10" [innerHTML]="basedOnImageName['header'] | safeHtml"></span>
                                    </div>
                                </div>
                            </div>
                            <div
                                [ngStyle]="{
                                    width:
                                        'calc(96% - ' +
                                        sessionConfig.catalogConfig.header.imageConfig.width +
                                        ' - ' +
                                        sessionConfig.catalogConfig.header.imageConfig.margin +
                                        ' - ' +
                                        sessionConfig.catalogConfig.header.imageConfig.margin +
                                        ')'
                                }"
                                class="editable text"
                                (cclClick)="openConfigDrawer('html', $event, 'header')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-collapsed">
                                    <div
                                        class="text-content"
                                        [innerHTML]="headerLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color':
                                                sessionConfig.catalogConfig.header.textConfig.background,
                                            color: sessionConfig.catalogConfig.header.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                            <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template>
                            <div class="clearfix "></div>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="sessionConfig.layout == 'l_square'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.header.regionConfig.background,
                        margin: sessionConfig.catalogConfig.header.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.header.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.header.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable img"
                                (cclClick)="openConfigDrawer('img', $event, 'header')"
                                title="Edit Session Image"
                                [ngStyle]="{
                                    height:
                                        +sessionConfig.catalogConfig.header.imageConfig.height.slice(0, -2) +
                                        +sessionConfig.catalogConfig.header.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    width:
                                        +sessionConfig.catalogConfig.header.imageConfig.width.slice(0, -2) +
                                        +sessionConfig.catalogConfig.header.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    'background-color': sessionConfig.catalogConfig.header.imageConfig.background,
                                    overflow: 'hidden'
                                }"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="img-info">
                                    <div
                                        class="img-content"
                                        [ngStyle]="{
                                            padding: '0px',
                                            height: sessionConfig.catalogConfig.header.imageConfig.height,
                                            width: sessionConfig.catalogConfig.header.imageConfig.width,
                                            'background-color':
                                                sessionConfig.catalogConfig.header.imageConfig.background,
                                            margin: sessionConfig.catalogConfig.header.imageConfig.margin,
                                            'border-radius':
                                                this.sessionConfig.layout == 'l_circular'
                                                    ? sessionConfig.catalogConfig.header.imageConfig.height
                                                    : '0px'
                                        }"
                                    >
                                    <div *ngIf="sessionConfig.catalogConfig['header'].imageConfig.basedOn == 'dynamic_img'" [innerHTML]="basedOnImageName['header'] | safeHtml"></div>

                                    <span *ngIf="sessionConfig.catalogConfig['header'].imageConfig.basedOn == 'speaker_img'" [ngStyle]="{
                                        display: 'inline-block',
                                        'margin-top':
                                            'calc(' +
                                            sessionConfig.catalogConfig.header.imageConfig.height +
                                            ' / 2 - 20px)'
                                    }" class="fs10" [innerHTML]="basedOnImageName['header'] | safeHtml"></span>
                                    </div>
                                </div>
                            </div>
                            <div
                                [ngStyle]="{
                                    width:
                                        'calc(96% - ' +
                                        sessionConfig.catalogConfig.header.imageConfig.width +
                                        ' - ' +
                                        sessionConfig.catalogConfig.header.imageConfig.margin +
                                        ' - ' +
                                        sessionConfig.catalogConfig.header.imageConfig.margin +
                                        ')'
                                }"
                                class="editable text"
                                (cclClick)="openConfigDrawer('html', $event, 'header')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-collapsed">
                                    <div
                                        class="text-content"
                                        [innerHTML]="headerLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color':
                                                sessionConfig.catalogConfig.header.textConfig.background,
                                            color: sessionConfig.catalogConfig.header.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                            <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div
                    *ngIf="sessionConfig.layout == 'l_noimage'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.header.regionConfig.background,
                        margin: sessionConfig.catalogConfig.header.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.header.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.header.regionConfig.corner
                    }"
                >
                    <div class="row mar-right0">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable text w100"
                                (cclClick)="openConfigDrawer('html', $event, 'header')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-collapsed">
                                    <div
                                        class="text-content"
                                        [innerHTML]="headerLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color':
                                                sessionConfig.catalogConfig.header.textConfig.background,
                                            color: sessionConfig.catalogConfig.header.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                            <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div
                    *ngIf="sessionConfig.layout == 'l_banner'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.header.regionConfig.background,
                        margin: sessionConfig.catalogConfig.header.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.header.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.header.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12" (cclClick)="openConfigDrawer('img', $event, 'header')"
                        title="Edit Session Image">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="banner-img">
                                <img alt="Banner"
                                    [src]="sessionConfig.catalogConfig.header.imageConfig.banner"
                                    class="w100 img-fluid"
                                    *ngIf="sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                    'dynamic_img' && sessionConfig.catalogConfig.header.imageConfig.banner != null"
                                />
                                <img alt="Banner"
                                        [src]="sessionConfig.catalogConfig.header.imageConfig.defaultThumbnailURL"
                                        class="w100 img-fluid"
                                        *ngIf="sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                        'thumbnail_img' && sessionConfig.catalogConfig.header.imageConfig.defaultThumbnailURL != null"
                                    />

                                    <span class="thumb-display-icon" *ngIf="sessionConfig.catalogConfig['header'].imageConfig.basedOn == 'thumbnail_img' && sessionConfig.catalogConfig.header.imageConfig.defaultThumbnailURL" [innerHTML]="headerThumbnailHtml"></span>
                                <div
                                    class="text-center aqua-color"
                                    *ngIf="sessionConfig.catalogConfig.header.imageConfig.banner == null && sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                    'dynamic_img'"
                                >
                                    Click to upload static image.
                                </div>
                            </div>





                            </div>
                        </div>

                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable text w100 banner-sibling"
                                (cclClick)="openConfigDrawer('html', $event, 'header')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-collapsed">
                                    <div
                                        class="text-content"
                                        [innerHTML]="headerLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color':
                                                sessionConfig.catalogConfig.header.textConfig.background,
                                            color: sessionConfig.catalogConfig.header.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>

                            <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div class="clearfix "></div>
            </div>
        </div>

        <div *ngIf="(baseUrl == 'highlighted' && sessionTemplateType['highlightedStyle'] == 'card') || (baseUrl == 'promoted' && sessionTemplateType['promotedStyle'] == 'card') || (baseUrl == 'general' && sessionTemplateType['generalStyle'] == 'card')" class="row row--builder card-layout justify-content-md-center">
            <div class="col col-sm-6 ">
                <div
                    [class.c-box]="!hover"
                    [class.c-box-nohover]="hover"
                    (cclClick)="openConfigDrawer('region', $event, 'header')"
                    title="Edit Region"
                >
                <div
                *ngIf="sessionConfig.layout == 'l_circular'"
                class="layout-box"
                [ngStyle]="{
                    'background-color': sessionConfig.catalogConfig.header.regionConfig.background,
                    margin: sessionConfig.catalogConfig.header.regionConfig.margin,
                    padding: sessionConfig.catalogConfig.header.regionConfig.padding,
                    'border-radius': sessionConfig.catalogConfig.header.regionConfig.corner
                }"
            >
                <div class="row">
                    <div class="col-sm-12 col-xs-12">
                        <div
                            class="editable img"
                            [ngStyle]="{
                                height:
                                    +sessionConfig.catalogConfig.header.imageConfig.height.slice(0, -2) +
                                    +sessionConfig.catalogConfig.header.imageConfig.margin.slice(0, -2) * 2 +
                                    14 +
                                    'px',
                                overflow: 'hidden'
                            }"
                            (cclClick)="openConfigDrawer('img', $event, 'header')"
                            title="Edit Speaker Image"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                            <div class="img-info">
                                <div
                                    class="img-content"
                                    [ngStyle]="{
                                        padding: '0px',
                                        height: sessionConfig.catalogConfig.header.imageConfig.height,
                                        width: sessionConfig.catalogConfig.header.imageConfig.width,
                                        'background-color':
                                            sessionConfig.catalogConfig.header.imageConfig.background,
                                        margin: sessionConfig.catalogConfig.header.imageConfig.margin,
                                        'border-radius':
                                            this.sessionConfig.layout == 'l_circular'
                                                ? sessionConfig.catalogConfig.header.imageConfig.height
                                                : '0px'
                                    }"
                                >
                                    <div
                                        *ngIf="
                                            sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                            'dynamic_img'
                                        "
                                        [innerHTML]="basedOnImageName['header'] | safeHtml"
                                    ></div>

                                    <div
                                        *ngIf="
                                            sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                            'thumbnail_img'
                                        "
                                        [innerHTML]="basedOnImageName['header'] | safeHtml"
                                    ></div>

                                    <span
                                        *ngIf="
                                            sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                            'speaker_img'
                                        "
                                        [ngStyle]="{
                                            display: 'inline-block',
                                            'margin-top':
                                                'calc(' +
                                                sessionConfig.catalogConfig.header.imageConfig.height +
                                                ' / 2 - 20px)'
                                        }"
                                        class="fs10"
                                        [innerHTML]="basedOnImageName['header'] | safeHtml"
                                    ></span>
                                </div>
                            </div>
                        </div>
                        <div
                            class="editable text"
                            (cclClick)="openConfigDrawer('html', $event, 'header')"
                            title="Edit Speaker Content"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                            <div class="text-info text-content-collapsed">
                                <div
                                    class="text-content"
                                    [innerHTML]="headerLayout | safeHtml"
                                    [ngStyle]="{
                                        position: 'relative',
                                        'word-wrap': 'break-word',
                                        'background-color':
                                            sessionConfig.catalogConfig.header.textConfig.background,
                                        color: sessionConfig.catalogConfig.header.textConfig.textColor
                                    }"
                                >
                            </div>
                            <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template>
                            </div>
                        </div>
                        <div class="clearfix "></div>
                    </div>
                </div>
            </div>
            <div
                *ngIf="sessionConfig.layout == 'l_square'"
                class="layout-box"
                [ngStyle]="{
                    'background-color': sessionConfig.catalogConfig.header.regionConfig.background,
                    margin: sessionConfig.catalogConfig.header.regionConfig.margin,
                    padding: sessionConfig.catalogConfig.header.regionConfig.padding,
                    'border-radius': sessionConfig.catalogConfig.header.regionConfig.corner
                }"
            >
                <div class="row">
                    <div class="col-sm-12 col-xs-12">
                        <div
                            class="editable img"
                            (cclClick)="openConfigDrawer('img', $event, 'header')"
                            title="Edit Speaker Image"
                            [ngStyle]="{
                                height:
                                    +sessionConfig.catalogConfig.header.imageConfig.height.slice(0, -2) +
                                    +sessionConfig.catalogConfig.header.imageConfig.margin.slice(0, -2) * 2 +
                                    14 +
                                    'px',
                                overflow: 'hidden'
                            }"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                            <div class="img-info">
                                <div
                                    class="img-content"
                                    [ngStyle]="{
                                        padding: '0px',
                                        height: sessionConfig.catalogConfig.header.imageConfig.height,
                                        width: sessionConfig.catalogConfig.header.imageConfig.width,
                                        'background-color':
                                            sessionConfig.catalogConfig.header.imageConfig.background,
                                        margin: sessionConfig.catalogConfig.header.imageConfig.margin,
                                        'border-radius':
                                            this.sessionConfig.layout == 'l_circular'
                                                ? sessionConfig.catalogConfig.header.imageConfig.height
                                                : '0px'
                                    }"
                                >
                                    <div
                                        *ngIf="
                                            sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                            'dynamic_img'
                                        "
                                        [innerHTML]="basedOnImageName['header'] | safeHtml"
                                    ></div>

                                    <div
                                        *ngIf="
                                            sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                            'thumbnail_img'
                                        "
                                        [innerHTML]="basedOnImageName['header'] | safeHtml"
                                    ></div>

                                    <span
                                        *ngIf="
                                            sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                            'speaker_img'
                                        "
                                        [ngStyle]="{
                                            display: 'inline-block',
                                            'margin-top':
                                                'calc(' +
                                                sessionConfig.catalogConfig.header.imageConfig.height +
                                                ' / 2 - 20px)'
                                        }"
                                        class="fs10"
                                        [innerHTML]="basedOnImageName['header'] | safeHtml"
                                    ></span>
                                </div>
                            </div>
                        </div>
                        <div
                            class="editable text"
                            (cclClick)="openConfigDrawer('html', $event, 'header')"
                            title="Edit Speaker Content"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                            <div class="text-info text-content-collapsed">
                                <div
                                    class="text-content"
                                    [innerHTML]="headerLayout | safeHtml"
                                    [ngStyle]="{
                                        position: 'relative',
                                        'word-wrap': 'break-word',
                                        'background-color':
                                            sessionConfig.catalogConfig.header.textConfig.background,
                                        color: sessionConfig.catalogConfig.header.textConfig.textColor
                                    }"
                                ></div>
                                <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix "></div>
            </div>
            <div
                *ngIf="sessionConfig.layout == 'l_noimage'"
                class="layout-box"
                [ngStyle]="{
                    'background-color': sessionConfig.catalogConfig.header.regionConfig.background,
                    margin: sessionConfig.catalogConfig.header.regionConfig.margin,
                    padding: sessionConfig.catalogConfig.header.regionConfig.padding,
                    'border-radius': sessionConfig.catalogConfig.header.regionConfig.corner
                }"
            >
                <div class="row mar-right0">
                    <div class="col-sm-12 col-xs-12">
                        <div
                            class="editable text w100"
                            (cclClick)="openConfigDrawer('html', $event, 'header')"
                            title="Edit Speaker Content"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                            <div class="text-info text-content-collapsed">
                                <div
                                    class="text-content"
                                    [innerHTML]="headerLayout | safeHtml"
                                    [ngStyle]="{
                                        position: 'relative',
                                        'word-wrap': 'break-word',
                                        'background-color':
                                            sessionConfig.catalogConfig.header.textConfig.background,
                                        color: sessionConfig.catalogConfig.header.textConfig.textColor
                                    }"
                                ></div>
                            </div>
                        </div>
                        <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template>
                    </div>
                </div>
                <div class="clearfix "></div>
            </div>
            <div
                *ngIf="sessionConfig.layout == 'l_banner'"
                class="layout-box"
                [ngStyle]="{
                    'background-color': sessionConfig.catalogConfig.header.regionConfig.background,
                    margin: sessionConfig.catalogConfig.header.regionConfig.margin,
                    padding: sessionConfig.catalogConfig.header.regionConfig.padding,
                    'border-radius': sessionConfig.catalogConfig.header.regionConfig.corner
                }"
            >
                <div class="row">
                    <div class="col-sm-12 col-xs-12" (cclClick)="openConfigDrawer('img', $event, 'header')"
                    title="Edit Speaker Image">
                        <div
                            class="editable banner-img-container"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                        <div class="banner-img">
                            <img alt="Banner"
                                [src]="sessionConfig.catalogConfig.header.imageConfig.banner"
                                class="w100 img-fluid"
                                *ngIf="sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                'dynamic_img' && sessionConfig.catalogConfig.header.imageConfig.banner != null"
                            />
                            <img alt="Banner"
                                    [src]="sessionConfig.catalogConfig.header.imageConfig.defaultThumbnailURL"
                                    class="w100 img-fluid"
                                    *ngIf="sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                    'thumbnail_img' && sessionConfig.catalogConfig.header.imageConfig.defaultThumbnailURL != null"
                                />
                                <span class="thumb-display-icon" *ngIf="sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                'thumbnail_img' && sessionConfig.catalogConfig.header.imageConfig.defaultThumbnailURL" [innerHTML]="headerThumbnailHtml"></span>
                            <div
                                class="text-center aqua-color"
                                *ngIf="sessionConfig.catalogConfig.header.imageConfig.banner == null && sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                                'dynamic_img'"
                            >
                                Click to upload static image.
                            </div>
                        </div>
                        <!-- <div class="banner-img" *ngIf="
                            sessionConfig.catalogConfig['header'].imageConfig.basedOn ==
                            'thumbnail_img'
                        ">
                                <img alt="Banner"
                                    [src]="sessionConfig.catalogConfig.header.imageConfig.webinarThumbnail"
                                    class="w100 img-fluid"
                                    *ngIf="sessionConfig.catalogConfig.header.imageConfig.webinarThumbnail != null"
                                />
                                <div
                                    class="text-center aqua-color"
                                    *ngIf="sessionConfig.catalogConfig.header.imageConfig.webinarThumbnail == null"
                                >
                                    Click to upload static image.
                                </div>
                            </div> -->
                            <!-- <div
                                class="banner-img"
                                [ngStyle]="{
                                    margin: sessionConfig.catalogConfig.header.imageConfig.margin
                                }"
                            >
                                <div
                                    [ngStyle]="{'background-color':sessionConfig.catalogConfig.header.imageConfig.background}"
                                >
                                    <img
                                        style="opacity:.8"
                                        alt="Banner"
                                        [src]="sessionConfig.catalogConfig.header.imageConfig.banner"
                                        class="w100 img-fluid"
                                        *ngIf="sessionConfig.catalogConfig.header.imageConfig.banner != null"
                                    />
                                </div>
                                <div
                                    class="text-center aqua-color"
                                    *ngIf="sessionConfig.catalogConfig.header.imageConfig.banner == null"
                                >
                                    Click to upload static image.
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-12 col-xs-12">
                        <div
                            class="editable text w100 banner-sibling"
                            (cclClick)="openConfigDrawer('html', $event, 'header')"
                            title="Edit Speaker Content"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                            <div class="text-info text-content-collapsed">
                                <div
                                    class="text-content"
                                    [innerHTML]="headerLayout | safeHtml"
                                    [ngStyle]="{
                                        position: 'relative',
                                        'word-wrap': 'break-word',
                                        'background-color':
                                            sessionConfig.catalogConfig.header.textConfig.background,
                                        color: sessionConfig.catalogConfig.header.textConfig.textColor
                                    }"
                                ></div>
                            </div>
                        </div>
                        <ng-template [ngTemplateOutlet]="buttonConfig"></ng-template>
                    </div>
                </div>
                <div class="clearfix "></div>
            </div>
                    <div class="clearfix "></div>
                </div>
            </div>

            <!-- <div class="col col-sm-6 mar-40"><div class="c-title--subsection ">EXPANDED</div></div>

        <div class="col col-sm-6 text-right "></div>

        <div class="col col-sm-12">
            <div
                [class.c-box]="!hover"
                [class.c-box-nohover]="hover"
                (cclClick)="openConfigDrawer('region', $event, 'body')"
            >
                <div
                    *ngIf="sessionConfig.layout == 'l_circular'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                        margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable img"
                                (cclClick)="openConfigDrawer('img', $event, 'body')"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                                [ngStyle]="{
                                    height:
                                        +sessionConfig.catalogConfig.body.imageConfig.height.slice(0, -2) +
                                        +sessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    width:
                                        +sessionConfig.catalogConfig.body.imageConfig.width.slice(0, -2) +
                                        +sessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    'background-color': sessionConfig.catalogConfig.body.imageConfig.background,
                                    overflow: 'hidden'
                                }"
                            >
                                <div class="img-info">
                                    <div
                                        class="img-content"
                                        [ngStyle]="{
                                            padding: '0px',
                                            height: sessionConfig.catalogConfig.body.imageConfig.height,
                                            width: sessionConfig.catalogConfig.body.imageConfig.width,
                                            'background-color': sessionConfig.catalogConfig.body.imageConfig.background,
                                            margin: sessionConfig.catalogConfig.body.imageConfig.margin,
                                            'border-radius':
                                                this.sessionConfig.layout == 'l_circular'
                                                    ? sessionConfig.catalogConfig.body.imageConfig.height
                                                    : '0px'
                                        }"
                                    >
                                        <div
                                            *ngIf="
                                                sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'dynamic_img'
                                            "
                                            [innerHTML]="basedOnImageName['body'] | safeHtml"
                                        ></div>

                                        <span
                                            *ngIf="
                                                sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'speaker_img'
                                            "
                                            [ngStyle]="{
                                                display: 'inline-block',
                                                'margin-top':
                                                    'calc(' +
                                                    sessionConfig.catalogConfig.body.imageConfig.height +
                                                    ' / 2 - 20px)'
                                            }"
                                            class="fs10"
                                            [innerHTML]="basedOnImageName['body'] | safeHtml"
                                        ></span>
                                    </div>
                                </div>
                            </div>
                            <div
                                [ngStyle]="{
                                    width:
                                        'calc(96% - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.width +
                                        ' - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.margin +
                                        ' - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.margin +
                                        ')'
                                }"
                                class="editable text"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-expanded">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color': sessionConfig.catalogConfig.body.textConfig.background,
                                            color: sessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                            <div class="clearfix "></div>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="sessionConfig.layout == 'l_square'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                        margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable img"
                                (cclClick)="openConfigDrawer('img', $event, 'body')"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                                [ngStyle]="{
                                    height:
                                        +sessionConfig.catalogConfig.body.imageConfig.height.slice(0, -2) +
                                        +sessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    width:
                                        +sessionConfig.catalogConfig.body.imageConfig.width.slice(0, -2) +
                                        +sessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    'background-color': sessionConfig.catalogConfig.body.imageConfig.background,
                                    overflow: 'hidden'
                                }"
                            >
                                <div class="img-info">
                                    <div
                                        class="img-content"
                                        [ngStyle]="{
                                            padding: '0px',
                                            height: sessionConfig.catalogConfig.body.imageConfig.height,
                                            width: sessionConfig.catalogConfig.body.imageConfig.width,
                                            'background-color': sessionConfig.catalogConfig.body.imageConfig.background,
                                            margin: sessionConfig.catalogConfig.body.imageConfig.margin,
                                            'border-radius':
                                                this.sessionConfig.layout == 'l_circular'
                                                    ? sessionConfig.catalogConfig.body.imageConfig.height
                                                    : '0px'
                                        }"
                                    >
                                        <div
                                            *ngIf="
                                                sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'dynamic_img'
                                            "
                                            [innerHTML]="basedOnImageName['body'] | safeHtml"
                                        ></div>

                                        <span
                                            *ngIf="
                                                sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'speaker_img'
                                            "
                                            [ngStyle]="{
                                                display: 'inline-block',
                                                'margin-top':
                                                    'calc(' +
                                                    sessionConfig.catalogConfig.body.imageConfig.height +
                                                    ' / 2 - 20px)'
                                            }"
                                            class="fs10"
                                            [innerHTML]="basedOnImageName['body'] | safeHtml"
                                        ></span>
                                    </div>
                                </div>
                            </div>
                            <div
                                [ngStyle]="{
                                    width:
                                        'calc(96% - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.width +
                                        ' - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.margin +
                                        ' - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.margin +
                                        ')'
                                }"
                                class="editable text"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-expanded">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color': sessionConfig.catalogConfig.body.textConfig.background,
                                            color: sessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div
                    *ngIf="sessionConfig.layout == 'l_noimage'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                        margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row mar-right0">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable text w100"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-expanded">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color': sessionConfig.catalogConfig.body.textConfig.background,
                                            color: sessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div
                    *ngIf="sessionConfig.layout == 'l_banner'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                        margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12" (cclClick)="openConfigDrawer('img', $event, 'body')">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="banner-img">
                                    <img
                                        [src]="sessionConfig.catalogConfig.body.imageConfig.banner"
                                        class="w100 img-fluid"
                                        *ngIf="sessionConfig.catalogConfig.body.imageConfig.banner != null"
                                    />
                                    <div
                                        class="text-center aqua-color"
                                        *ngIf="sessionConfig.catalogConfig.body.imageConfig.banner == null"
                                    >
                                        Click to upload static image.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable text w100 banner-sibling"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-expanded">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color': sessionConfig.catalogConfig.body.textConfig.background,
                                            color: sessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div class="clearfix "></div>
            </div>
        </div> -->
        </div>
        

        <div class="col col-sm-6 mar-40"><div class="c-title--subsection ">EXPANDED</div></div>

        <div class="col col-sm-6 text-right "></div>

        <div *ngIf="(((baseUrl == 'highlighted' && sessionTemplateType['highlightedStyle'] == 'list') || (baseUrl == 'promoted' && sessionTemplateType['promotedStyle'] == 'list') || (baseUrl == 'general' && sessionTemplateType['generalStyle'] == 'list')) || (!sessionTemplateType['generalStyle'] && !sessionTemplateType['promotedStyle'] && !sessionTemplateType['highlightedStyle']))" class="col col-sm-12">
            <div
                [class.c-box]="!hover"
                [class.c-box-nohover]="hover"
                (cclClick)="openConfigDrawer('region', $event, 'body')"
                title="Edit Region"
            >
                <div
                    *ngIf="sessionConfig.layout == 'l_circular'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                        margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable img"
                                (cclClick)="openConfigDrawer('img', $event, 'body')"
                                title="Edit Session Image"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                                [ngStyle]="{
                                    height:
                                        +sessionConfig.catalogConfig.body.imageConfig.height.slice(0, -2) +
                                        +sessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    width:
                                        +sessionConfig.catalogConfig.body.imageConfig.width.slice(0, -2) +
                                        +sessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    'background-color': sessionConfig.catalogConfig.body.imageConfig.background,
                                    overflow: 'hidden'
                                }"
                            >
                                <div class="img-info">
                                    <div
                                        class="img-content"
                                        [ngStyle]="{
                                            padding: '0px',
                                            height: sessionConfig.catalogConfig.body.imageConfig.height,
                                            width: sessionConfig.catalogConfig.body.imageConfig.width,
                                            'background-color': sessionConfig.catalogConfig.body.imageConfig.background,
                                            margin: sessionConfig.catalogConfig.body.imageConfig.margin,
                                            'border-radius':
                                                this.sessionConfig.layout == 'l_circular'
                                                    ? sessionConfig.catalogConfig.body.imageConfig.height
                                                    : '0px'
                                        }"
                                    >
                                    <div *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'dynamic_img'" [innerHTML]="basedOnImageName['body'] | safeHtml"></div>

                                    <span *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'speaker_img'" [ngStyle]="{
                                        display: 'inline-block',
                                        'margin-top':
                                            'calc(' +
                                            sessionConfig.catalogConfig.body.imageConfig.height +
                                            ' / 2 - 20px)'
                                    }" class="fs10" [innerHTML]="basedOnImageName['body'] | safeHtml"></span>
                                    </div>
                                </div>
                            </div>
                            <div
                                [ngStyle]="{
                                    width:
                                        'calc(96% - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.width +
                                        ' - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.margin +
                                        ' - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.margin +
                                        ')'
                                }"
                                class="editable text"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-expanded">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color': sessionConfig.catalogConfig.body.textConfig.background,
                                            color: sessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                            <div class="clearfix "></div>
                        </div>
                        <div class="col-sm-12 col-xs-12 session-asset" (cclClick)="openConfigDrawer('assets', $event, 'body')"
                        title="Session Assets">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="asset-drawer">
                                <div
                                    class="text-center black-color"
                                >
                                    Session Assets
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="sessionConfig.layout == 'l_square'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                        margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable img"
                                (cclClick)="openConfigDrawer('img', $event, 'body')"
                                title="Edit Session Image"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                                [ngStyle]="{
                                    height:
                                        +sessionConfig.catalogConfig.body.imageConfig.height.slice(0, -2) +
                                        +sessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    width:
                                        +sessionConfig.catalogConfig.body.imageConfig.width.slice(0, -2) +
                                        +sessionConfig.catalogConfig.body.imageConfig.margin.slice(0, -2) * 2 +
                                        14 +
                                        'px',
                                    'background-color': sessionConfig.catalogConfig.body.imageConfig.background,
                                    overflow: 'hidden'
                                }"
                            >
                                <div class="img-info">
                                    <div
                                        class="img-content"
                                        [ngStyle]="{
                                            padding: '0px',
                                            height: sessionConfig.catalogConfig.body.imageConfig.height,
                                            width: sessionConfig.catalogConfig.body.imageConfig.width,
                                            'background-color': sessionConfig.catalogConfig.body.imageConfig.background,
                                            margin: sessionConfig.catalogConfig.body.imageConfig.margin,
                                            'border-radius':
                                                this.sessionConfig.layout == 'l_circular'
                                                    ? sessionConfig.catalogConfig.body.imageConfig.height
                                                    : '0px'
                                        }"
                                    >
                                    <div *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'dynamic_img'" [innerHTML]="basedOnImageName['body'] | safeHtml"></div>

                                    <span *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'speaker_img'" [ngStyle]="{
                                        display: 'inline-block',
                                        'margin-top':
                                            'calc(' +
                                            sessionConfig.catalogConfig.body.imageConfig.height +
                                            ' / 2 - 20px)'
                                    }" class="fs10" [innerHTML]="basedOnImageName['body'] | safeHtml"></span>
                                    </div>
                                </div>
                            </div>
                            <div
                                [ngStyle]="{
                                    width:
                                        'calc(96% - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.width +
                                        ' - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.margin +
                                        ' - ' +
                                        sessionConfig.catalogConfig.body.imageConfig.margin +
                                        ')'
                                }"
                                class="editable text"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-expanded">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color': sessionConfig.catalogConfig.body.textConfig.background,
                                            color: sessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-xs-12 session-asset" (cclClick)="openConfigDrawer('assets', $event, 'body')"
                        title="Session Assets">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="asset-drawer">
                                <div
                                    class="text-center black-color"
                                >
                                    Session Assets
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div
                    *ngIf="sessionConfig.layout == 'l_noimage'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                        margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row mar-right0">
                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable text w100"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-expanded">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color': sessionConfig.catalogConfig.body.textConfig.background,
                                            color: sessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-xs-12 session-asset" (cclClick)="openConfigDrawer('assets', $event, 'body')"
                        title="Session Assets">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="asset-drawer">
                                <div
                                    class="text-center black-color"
                                >
                                    Session Assets
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div
                    *ngIf="sessionConfig.layout == 'l_banner'"
                    class="layout-box"
                    [ngStyle]="{
                        'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                        margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                        padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                        'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                    }"
                >
                    <div class="row">
                        <div class="col-sm-12 col-xs-12" (cclClick)="openConfigDrawer('img', $event, 'body')"
                        title="Edit Session Image">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="banner-img">
                                <img alt="Banner"
                                    [src]="sessionConfig.catalogConfig.body.imageConfig.banner"
                                    class="w100 img-fluid"
                                    *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                    'dynamic_img' && sessionConfig.catalogConfig.body.imageConfig.banner != null"
                                />
                                <img alt="Banner"
                                        [src]="sessionConfig.catalogConfig.body.imageConfig.defaultThumbnailURL"
                                        class="w100 img-fluid"
                                        *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                        'thumbnail_img' && sessionConfig.catalogConfig.body.imageConfig.defaultThumbnailURL != null"
                                    />
                                    <span class="thumb-display-icon" *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                    'thumbnail_img' && sessionConfig.catalogConfig.body.imageConfig.defaultThumbnailURL" [innerHTML]="bodyThumbnailHtml"></span>

                                <div
                                    class="text-center aqua-color"
                                    *ngIf="sessionConfig.catalogConfig.body.imageConfig.banner == null && sessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                    'dynamic_img'"
                                >
                                    Click to upload static image.
                                </div>
                            </div>
                            </div>
                        </div>

                        <div class="col-sm-12 col-xs-12">
                            <div
                                class="editable text w100 banner-sibling"
                                (cclClick)="openConfigDrawer('html', $event, 'body')"
                                title="Edit Session Content"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                                <div class="text-info text-content-expanded">
                                    <div
                                        class="text-content"
                                        [innerHTML]="bodyLayout | safeHtml"
                                        [ngStyle]="{
                                            position: 'relative',
                                            'word-wrap': 'break-word',
                                            'background-color': sessionConfig.catalogConfig.body.textConfig.background,
                                            color: sessionConfig.catalogConfig.body.textConfig.textColor
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-xs-12 session-asset" (cclClick)="openConfigDrawer('assets', $event, 'body')"
                        title="Session Assets">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="asset-drawer">
                                <div
                                    class="text-center black-color"
                                >
                                    Session Assets
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix "></div>
                </div>
                <div class="clearfix "></div>
            </div>
        </div>

        <div *ngIf="(baseUrl == 'highlighted' && sessionTemplateType['highlightedStyle'] == 'card') || (baseUrl == 'promoted' && sessionTemplateType['promotedStyle'] == 'card') || (baseUrl == 'general' && sessionTemplateType['generalStyle'] == 'card')" class="row row--builder card-layout justify-content-md-center">
            <div class="col col-sm-6 ">
                <div
                    [class.c-box]="!hover"
                    [class.c-box-nohover]="hover"
                    (cclClick)="openConfigDrawer('region', $event, 'header')"
                    title="Edit Region"
                >
                <div
                *ngIf="sessionConfig.layout == 'l_circular'"
                class="layout-box"
                [ngStyle]="{
                    'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                    margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                    padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                    'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                }"
            >
                <div class="row">
                    <div class="col-sm-12 col-xs-12">
                        <div
                            class="editable img"
                            (cclClick)="openConfigDrawer('img', $event, 'body')"
                            title="Edit Session Image"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                            [ngStyle]="{
                                height:
                                    +sessionConfig.catalogConfig.header.imageConfig.height.slice(0, -2) +
                                    +sessionConfig.catalogConfig.header.imageConfig.margin.slice(0, -2) * 2 +
                                    14 +
                                    'px',
                                overflow: 'hidden'
                            }"
                        >
                            <div class="img-info">
                                <div
                                    class="img-content"
                                    [ngStyle]="{
                                        padding: '0px',
                                        height: sessionConfig.catalogConfig.header.imageConfig.height,
                                        width: sessionConfig.catalogConfig.header.imageConfig.width,
                                        'background-color':
                                            sessionConfig.catalogConfig.header.imageConfig.background,
                                        margin: sessionConfig.catalogConfig.header.imageConfig.margin,
                                        'border-radius':
                                            this.sessionConfig.layout == 'l_circular'
                                                ? sessionConfig.catalogConfig.header.imageConfig.height
                                                : '0px'
                                    }"
                                >
                                <div *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'dynamic_img'" [innerHTML]="basedOnImageName['body'] | safeHtml"></div>
                                <div
                                *ngIf="
                                    sessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                    'thumbnail_img'
                                "
                                [innerHTML]="basedOnImageName['body'] | safeHtml"
                            ></div>
                                <span *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'speaker_img'" [ngStyle]="{
                                    display: 'inline-block',
                                    'margin-top':
                                        'calc(' +
                                        sessionConfig.catalogConfig.body.imageConfig.height +
                                        ' / 2 - 20px)'
                                }" class="fs10" [innerHTML]="basedOnImageName['body'] | safeHtml"></span>
                                </div>
                            </div>
                        </div>
                        <div
                     
                            class="editable text"
                            (cclClick)="openConfigDrawer('html', $event, 'body')"
                            title="Edit Session Content"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                            <div class="text-info text-content-expanded">
                                <div
                                    class="text-content"
                                    [innerHTML]="bodyLayout | safeHtml"
                                    [ngStyle]="{
                                        position: 'relative',
                                        'word-wrap': 'break-word',
                                        'background-color':
                                            sessionConfig.catalogConfig.header.textConfig.background,
                                        color: sessionConfig.catalogConfig.header.textConfig.textColor
                                    }"
                                ></div>
                            </div>
                        </div>
                        <div class="clearfix "></div>
                    </div>
                    <div class="col-sm-12 col-xs-12 session-asset" (cclClick)="openConfigDrawer('assets', $event, 'body')"
                        title="Session Assets">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="asset-drawer">
                                <div
                                    class="text-center black-color"
                                >
                                    Session Assets
                                </div>
                            </div>
                            </div>
                        </div>
                </div>
            </div>
            <div
                *ngIf="sessionConfig.layout == 'l_square'"
                class="layout-box"
                [ngStyle]="{
                    'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                    margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                    padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                    'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                }"
            >
                <div class="row">
                    <div class="col-sm-12 col-xs-12">
                        <div
                            class="editable img"
                            (cclClick)="openConfigDrawer('img', $event, 'body')"
                            title="Edit Session Image"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                            [ngStyle]="{
                                height:
                                    +sessionConfig.catalogConfig.header.imageConfig.height.slice(0, -2) +
                                    +sessionConfig.catalogConfig.header.imageConfig.margin.slice(0, -2) * 2 +
                                    14 +
                                    'px',
                                overflow: 'hidden'
                            }"
                        >
                            <div class="img-info">
                                <div
                                    class="img-content"
                                    [ngStyle]="{
                                        padding: '0px',
                                        height: sessionConfig.catalogConfig.header.imageConfig.height,
                                        width: sessionConfig.catalogConfig.header.imageConfig.width,
                                        'background-color':
                                            sessionConfig.catalogConfig.header.imageConfig.background,
                                        margin: sessionConfig.catalogConfig.header.imageConfig.margin,
                                        'border-radius':
                                            this.sessionConfig.layout == 'l_circular'
                                                ? sessionConfig.catalogConfig.header.imageConfig.height
                                                : '0px'
                                    }"
                                >
                                <div *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'dynamic_img'" [innerHTML]="basedOnImageName['body'] | safeHtml"></div>
                                <div
                                *ngIf="
                                    sessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                    'thumbnail_img'
                                "
                                [innerHTML]="basedOnImageName['body'] | safeHtml"
                            ></div>
                                <span *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn == 'speaker_img'" [ngStyle]="{
                                    display: 'inline-block',
                                    'margin-top':
                                        'calc(' +
                                        sessionConfig.catalogConfig.body.imageConfig.height +
                                        ' / 2 - 20px)'
                                }" class="fs10" [innerHTML]="basedOnImageName['body'] | safeHtml"></span>
                                </div>
                            </div>
                        </div>
                        <div
                            class="editable text"
                            (cclClick)="openConfigDrawer('html', $event, 'body')"
                            title="Edit Session Content"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                            <div class="text-info text-content-expanded">
                                <div
                                    class="text-content"
                                    [innerHTML]="bodyLayout | safeHtml"
                                    [ngStyle]="{
                                        position: 'relative',
                                        'word-wrap': 'break-word',
                                        'background-color':
                                            sessionConfig.catalogConfig.header.textConfig.background,
                                        color: sessionConfig.catalogConfig.header.textConfig.textColor
                                    }"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-xs-12 session-asset" (cclClick)="openConfigDrawer('assets', $event, 'body')"
                        title="Session Assets">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="asset-drawer">
                                <div
                                    class="text-center black-color"
                                >
                                    Session Assets
                                </div>
                            </div>
                            </div>
                        </div>
                </div>
                <div class="clearfix "></div>
            </div>
            <div
                *ngIf="sessionConfig.layout == 'l_noimage'"
                class="layout-box"
                [ngStyle]="{
                    'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                    margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                    padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                    'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                }"
            >
                <div class="row mar-right0">
                    <div class="col-sm-12 col-xs-12">
                        <div
                            class="editable text w100"
                            (cclClick)="openConfigDrawer('html', $event, 'body')"
                            title="Edit Session Content"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                            <div class="text-info text-content-expanded">
                                <div
                                    class="text-content"
                                    [innerHTML]="bodyLayout | safeHtml"
                                    [ngStyle]="{
                                        position: 'relative',
                                        'word-wrap': 'break-word',
                                        'background-color':
                                            sessionConfig.catalogConfig.header.textConfig.background,
                                        color: sessionConfig.catalogConfig.header.textConfig.textColor
                                    }"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-xs-12 session-asset" (cclClick)="openConfigDrawer('assets', $event, 'body')"
                        title="Session Assets">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="asset-drawer">
                                <div
                                    class="text-center black-color"
                                >
                                    Session Assets
                                </div>
                            </div>
                            </div>
                        </div>
                </div>
                <div class="clearfix "></div>
            </div>
            <div
                *ngIf="sessionConfig.layout == 'l_banner'"
                class="layout-box"
                [ngStyle]="{
                    'background-color': sessionConfig.catalogConfig.body.regionConfig.background,
                    margin: sessionConfig.catalogConfig.body.regionConfig.margin,
                    padding: sessionConfig.catalogConfig.body.regionConfig.padding,
                    'border-radius': sessionConfig.catalogConfig.body.regionConfig.corner
                }"
            >
                <div class="row">
                    <div class="col-sm-12 col-xs-12" (cclClick)="openConfigDrawer('img', $event, 'body')"
                    title="Edit Session Image">
                        <div
                            class="editable banner-img-container"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                        <div class="banner-img">
                            <img alt="Banner"
                                [src]="sessionConfig.catalogConfig.body.imageConfig.banner"
                                class="w100 img-fluid"
                                *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                'dynamic_img' && sessionConfig.catalogConfig.body.imageConfig.banner != null"
                            />
                            <img alt="Banner"
                                    [src]="sessionConfig.catalogConfig.body.imageConfig.defaultThumbnailURL"
                                    class="w100 img-fluid"
                                    *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                    'thumbnail_img' && sessionConfig.catalogConfig.body.imageConfig.defaultThumbnailURL != null"
                                />
                                <span class="thumb-display-icon" *ngIf="sessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                'thumbnail_img' && sessionConfig.catalogConfig.body.imageConfig.defaultThumbnailURL" [innerHTML]="bodyThumbnailHtml"></span>

                            <div
                                class="text-center aqua-color"
                                *ngIf="sessionConfig.catalogConfig.body.imageConfig.banner == null && sessionConfig.catalogConfig['body'].imageConfig.basedOn ==
                                'dynamic_img'"
                            >
                                Click to upload static image.
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="col-sm-12 col-xs-12">
                        <div
                            class="editable text w100 banner-sibling"
                            (cclClick)="openConfigDrawer('html', $event, 'body')"
                            title="Edit Session Content"
                            (mouseout)="hover = false"
                            (mouseover)="hover = true"
                        >
                            <div class="text-info text-content-expanded">
                                <div
                                    class="text-content"
                                    [innerHTML]="bodyLayout | safeHtml"
                                    [ngStyle]="{
                                        position: 'relative',
                                        'word-wrap': 'break-word',
                                        'background-color':
                                            sessionConfig.catalogConfig.header.textConfig.background,
                                        color: sessionConfig.catalogConfig.header.textConfig.textColor
                                    }"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-xs-12 session-asset" (cclClick)="openConfigDrawer('assets', $event, 'body')"
                        title="Session Assets">
                            <div
                                class="editable banner-img-container"
                                (mouseout)="hover = false"
                                (mouseover)="hover = true"
                            >
                            <div class="asset-drawer">
                                <div
                                    class="text-center black-color"
                                >
                                    Session Assets
                                </div>
                            </div>
                            </div>
                        </div>
                </div>
                <div class="clearfix "></div>
            </div>
                <div class="clearfix "></div>
            </div>
        </div>
        </div>
        
    </div>
</ccl-content-section>

<ng-template #buttonConfig>
    <div
        class="button-config-handler"
        *ngIf="baseUrl == 'general'"
        (mouseout)="hover = false"
        (mouseover)="hover = true"
    >
        <div title="Icons" *ngIf="selectedTab == 'loggedIn'">
            <span><i class="fa fa-lg" [ngClass]="sessionConfig.catalogConfig.buttonConfig.favIcon" title="Favorite"></i></span>
            <span><i class="fa fa-lg" [ngClass]="sessionConfig.catalogConfig.buttonConfig.regIcon" title="Register"></i></span>
        </div>
    </div>
</ng-template>
